.ux-textarea-field {
  display: inline-block;
  position: relative;
  width: 100%;
}
